(function(){
  function wire(clone){
    var rail=clone.querySelector('.dj-mp__rail');
    var arrow=clone.querySelector('.dj-mp__arrow');
    if(!rail) return;
    function upd(){ var end=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4; clone.classList.toggle('dj-mp--end', end); }
    rail.addEventListener('scroll', upd, {passive:true});
    if(arrow){ arrow.addEventListener('click', function(){ rail.scrollBy({left:Math.round(rail.clientWidth*0.75), behavior:'smooth'}); }); }
    try{ new ResizeObserver(upd).observe(rail); }catch(e){}
    window.addEventListener('resize', upd);
    setTimeout(upd, 60); setTimeout(upd, 400);
  }
  function inject(){
    var src=document.querySelector('.dj-mp[hidden]');
    if(!src) return;
    var drawers=document.querySelectorAll('.menu-drawer');
    for(var i=0;i<drawers.length;i++){
      var d=drawers[i];
      if(d.querySelector('.dj-mp-injected')) continue;
      var c=src.cloneNode(true);
      c.removeAttribute('hidden');
      c.classList.add('dj-mp-injected');
      d.appendChild(c);
      wire(c);
    }
  }
  function boot(){
    inject();
    var n=0;
    var iv=setInterval(function(){ inject(); if(++n>60){ clearInterval(iv); } }, 500);
    try{
      var t=null;
      var mo=new MutationObserver(function(){ if(t) return; t=setTimeout(function(){ t=null; inject(); }, 120); });
      mo.observe(document.documentElement,{childList:true,subtree:true});
    }catch(e){}
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
